// Sets the background color of the product label type badge
const getServiceBadgeColor = (product) => {
    // Sets the background color of the service type badge
    return product["productLabel"] ? (
        product["productLabel"].toLowerCase() === "novo serviço" ? "yellowBadge"
            : product["productLabel"].toLowerCase() === "menor preço" ? "greenBadge"
                : product["productLabel"].toLowerCase() === "unidade digital" ? "grayBadge"
                    : "redBadge"
    ) : "";
}

export default getServiceBadgeColor;
